module.exports = __webpack_public_path__ + "media/images/puzzle/puzzle_45-11e66242d37a699309c81a8461c8b2d8.png";